import { render, staticRenderFns } from "./edit-package-dialog.vue?vue&type=template&id=2d8edb70&"
import script from "./edit-package-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-package-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports